import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIceRoad = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "ice-road" }),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "15 2.25 17.25 3.75 19.5 2.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 17.25,
			y1: 12.75,
			x2: 17.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "15 11.25 17.25 9.75 19.5 11.25"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "21.75 4.5 20.25 6.75 21.75 9"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 11.25,
			y1: 6.75,
			x2: 23.25,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "12.75 4.5 14.25 6.75 12.75 9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 3,
			cy: 21,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 13.5,
			cy: 21,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.622,21.75H16.5a1.5,1.5,0,0,0,1.5-1.5v-1.5a3,3,0,0,0-3-3H13.5l-2.585-5.171A1.5,1.5,0,0,0,9.573,9.75H6a1.5,1.5,0,0,0-1.5,1.5v4.5H.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 11.378,
			y1: 21.75,
			x2: 5.122,
			y2: 21.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 4.5,
			y1: 15.75,
			x2: 13.5,
			y2: 15.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 18,
			y1: 19.5,
			x2: 21.013,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M23.25,15.146A4.09,4.09,0,0,0,21,19.125,4.09,4.09,0,0,0,23.25,23.1"
		})
	]
});
export default SvgIceRoad;
